<template>
  <div>
    <a-form :form="form" @submit.prevent="handleSubmit">
      <template v-for="(item, index) of formList">
        <div v-if="item.inputType==='textarea'" :key="index">
          <a-form-item v-if="item.isShow"
                       class="textarea-icon"
                       :label="item.label"
                       has-feedback
                       :extra="item.extra"
                       v-bind="itemLayout"
          >
            <a-textarea v-decorator="item.props" :rows="4" :placeholder="item.placeholder" :disabled="item.disabled"/>
          </a-form-item>
        </div>

        <div v-if="item.inputType=== 'select'" :key="index">
          <a-form-item
            v-if="item.isShow"
            :label="item.label"
            has-feedback
            v-bind="itemLayout"
          >
            <a-select
              @change="(e) => {item.handle && item.handle(e)}"
              v-decorator="item.props"
              :mode="item.mode || 'default'"
              :disabled="item.disabled"
              :placeholder="item.placeholder">
              <a-select-option
                v-for="(el, order) of item.options"
                :key="order"
                :value="el.value">
                {{el.label}}
              </a-select-option>
            </a-select>
          </a-form-item>
        </div>

        <div v-if="item.inputType=== 'treeSelect'" :key="index">
          <a-form-item
            v-if="item.isShow"
            :label="item.label"
            has-feedback
            v-bind="itemLayout"
          >
            <a-tree-select
              @change="(e) => {item.handle && item.handle(e)}"
              style="width: 100%"
              allow-clear
              tree-checkable
              tree-node-filter-prop="title"
              v-decorator="item.props"
              :placeholder='item.placeholder'
              :disabled="item.disabled"
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            >
              <a-tree-select-node v-for="eve of item.options" :title='eve.label' :value='`${eve.value}`'
                                  :key='eve.value'>
                <a-tree-select-node v-if="eve.children.length" v-for="el of eve.children" :title='el.label'
                                    :value='`${el.value}`' :key='el.value'>
                  <a-tree-select-node v-if="el.children.length" v-for="part of el.children" :title='part.label'
                                      :value='`${part.value}`' :key='part.value'>
                  </a-tree-select-node>
                </a-tree-select-node>
              </a-tree-select-node>

            </a-tree-select>
          </a-form-item>
        </div>

        <div v-if="item.inputType==='transfer'" :key="index">
          <a-form-item
            v-if="item.isShow"
            :label="item.label"
            v-bind="itemLayout"
          >
            <a-transfer
              :listStyle="{ width: '42%', height: '250px' }"
              v-decorator="item.props"
              :dataSource="item.options"
              :targetKeys="targetKeys"
              :selectedKeys="selectedKeys"
              :disabled="item.disabled"
              :filterOption="transferFilter"
              @change="transferChange"
              @selectChange="transferSelectChange"
              :titles="item.titles || ['Source', 'Target']"
              :render="item => item.title"
              showSearch
            />

          </a-form-item>
        </div>
      </template>

      <a-form-item :wrapper-col="{ span: 8, offset: 9}">
        <a-button type="primary" html-type="submit" size="large">确定</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
let communityList = [
  {'value': 1, 'label': '浩邈体验小区'}, {'value': 2, 'label': '实施部'}, {
    'value': 3,
    'label': '汇通集团小区'
  }, {'value': 4, 'label': '厦门第一小区'}, {'value': 5, 'label': '新景一期'}, {'value': 6, 'label': '意林小区'}, {
    'value': 7,
    'label': '景园春小区'
  }, {'value': 10, 'label': '厦门第二小区'}, {'value': 11, 'label': '御品蓝湾'}, {'value': 15, 'label': '新景中心C栋'}, {
    'value': 16,
    'label': '中交和美新城1号楼'
  }, {'value': 17, 'label': '中交和美新城2号楼'}, {'value': 18, 'label': '诚毅小区'}, {
    'value': 19,
    'label': '新景世纪城24'
  }, {'value': 21, 'label': '小苑雅居'}, {'value': 24, 'label': '厦门第三小区'}, {
    'value': 25,
    'label': '测试一下物业公司没显示'
  }, {'value': 26, 'label': '海峡国际社区'}, {'value': 28, 'label': '浩邈测试小区'}, {
    'value': 29,
    'label': '厦门第五小区'
  }, {'value': 31, 'label': 'alan的小区'}, {'value': 33, 'label': '泉州测试小区'}, {
    'value': 1045,
    'label': '江南春晓'
  }, {'value': 1046, 'label': '3213123'}, {'value': 1047, 'label': 'r福满山庄'}, {
    'value': 1048,
    'label': 'zz小区'
  }, {'value': 1050, 'label': '保利叶语'}, {'value': 1051, 'label': 'alan的小区123'}, {
    'value': 1052,
    'label': '莆田小区'
  }, {'value': 1053, 'label': '明发半岛'}, {'value': 1055, 'label': '北海'}, {'value': 1056, 'label': '风和日丽'}
];
let cityList = [
  {
    'parent_id': 0,
    'value': 1,
    'label': '北京市',
    'children': [{'parent_id': 1, 'value': 2, 'label': '北京市市辖区'}]
  }, {
    'parent_id': 0,
    'value': 19,
    'label': '天津市',
    'children': [{'parent_id': 19, 'value': 20, 'label': '天津市市辖区'}]
  }, {
    'parent_id': 0,
    'value': 37,
    'label': '河北省',
    'children': [{'parent_id': 37, 'value': 38, 'label': '石家庄市'}, {
      'parent_id': 37,
      'value': 61,
      'label': '唐山市'
    }, {'parent_id': 37, 'value': 76, 'label': '秦皇岛市'}, {
      'parent_id': 37,
      'value': 84,
      'label': '邯郸市'
    }, {'parent_id': 37, 'value': 103, 'label': '邢台市'}, {
      'parent_id': 37,
      'value': 123,
      'label': '保定市'
    }, {'parent_id': 37, 'value': 148, 'label': '张家口市'}, {
      'parent_id': 37,
      'value': 165,
      'label': '承德市'
    }, {'parent_id': 37, 'value': 177, 'label': '沧州市'}, {
      'parent_id': 37,
      'value': 194,
      'label': '廊坊市'
    }, {'parent_id': 37, 'value': 205, 'label': '衡水市'}]
  }, {
    'parent_id': 0,
    'value': 217,
    'label': '山西省',
    'children': [{'parent_id': 217, 'value': 218, 'label': '太原市'}, {
      'parent_id': 217,
      'value': 229,
      'label': '大同市'
    }, {'parent_id': 217, 'value': 241, 'label': '阳泉市'}, {
      'parent_id': 217,
      'value': 247,
      'label': '长治市'
    }, {'parent_id': 217, 'value': 261, 'label': '晋城市'}, {
      'parent_id': 217,
      'value': 268,
      'label': '朔州市'
    }, {'parent_id': 217, 'value': 275, 'label': '晋中市'}, {
      'parent_id': 217,
      'value': 287,
      'label': '运城市'
    }, {'parent_id': 217, 'value': 301, 'label': '忻州市'}, {
      'parent_id': 217,
      'value': 316,
      'label': '临汾市'
    }, {'parent_id': 217, 'value': 334, 'label': '吕梁市'}]
  }, {
    'parent_id': 0,
    'value': 348,
    'label': '内蒙古自治区',
    'children': [{'parent_id': 348, 'value': 349, 'label': '呼和浩特市'}, {
      'parent_id': 348,
      'value': 359,
      'label': '包头市'
    }, {'parent_id': 348, 'value': 369, 'label': '乌海市'}, {
      'parent_id': 348,
      'value': 373,
      'label': '赤峰市'
    }, {'parent_id': 348, 'value': 386, 'label': '通辽市'}, {
      'parent_id': 348,
      'value': 395,
      'label': '鄂尔多斯市'
    }, {'parent_id': 348, 'value': 405, 'label': '呼伦贝尔市'}, {
      'parent_id': 348,
      'value': 420,
      'label': '巴彦淖尔市'
    }, {'parent_id': 348, 'value': 428, 'label': '乌兰察布市'}, {
      'parent_id': 348,
      'value': 440,
      'label': '兴安盟'
    }, {'parent_id': 348, 'value': 447, 'label': '锡林郭勒盟'}, {'parent_id': 348, 'value': 460, 'label': '阿拉善盟'}]
  }, {
    'parent_id': 0,
    'value': 464,
    'label': '辽宁省',
    'children': [{'parent_id': 464, 'value': 465, 'label': '沈阳市'}, {
      'parent_id': 464,
      'value': 479,
      'label': '大连市'
    }, {'parent_id': 464, 'value': 490, 'label': '鞍山市'}, {
      'parent_id': 464,
      'value': 498,
      'label': '抚顺市'
    }, {'parent_id': 464, 'value': 506, 'label': '本溪市'}, {
      'parent_id': 464,
      'value': 513,
      'label': '丹东市'
    }, {'parent_id': 464, 'value': 520, 'label': '锦州市'}, {
      'parent_id': 464,
      'value': 528,
      'label': '营口市'
    }, {'parent_id': 464, 'value': 535, 'label': '阜新市'}, {
      'parent_id': 464,
      'value': 543,
      'label': '辽阳市'
    }, {'parent_id': 464, 'value': 551, 'label': '盘锦市'}, {
      'parent_id': 464,
      'value': 556,
      'label': '铁岭市'
    }, {'parent_id': 464, 'value': 564, 'label': '朝阳市'}, {'parent_id': 464, 'value': 572, 'label': '葫芦岛市'}]
  }, {
    'parent_id': 0,
    'value': 579,
    'label': '吉林省',
    'children': [{'parent_id': 579, 'value': 580, 'label': '长春市'}, {
      'parent_id': 579,
      'value': 591,
      'label': '吉林市'
    }, {'parent_id': 579, 'value': 601, 'label': '四平市'}, {
      'parent_id': 579,
      'value': 608,
      'label': '辽源市'
    }, {'parent_id': 579, 'value': 613, 'label': '通化市'}, {
      'parent_id': 579,
      'value': 621,
      'label': '白山市'
    }, {'parent_id': 579, 'value': 628, 'label': '松原市'}, {
      'parent_id': 579,
      'value': 634,
      'label': '白城市'
    }, {'parent_id': 579, 'value': 640, 'label': '延边朝鲜族自治州'}]
  }, {
    'parent_id': 0,
    'value': 649,
    'label': '黑龙江省',
    'children': [{'parent_id': 649, 'value': 650, 'label': '哈尔滨市'}, {
      'parent_id': 649,
      'value': 669,
      'label': '齐齐哈尔市'
    }, {'parent_id': 649, 'value': 686, 'label': '鸡西市'}, {
      'parent_id': 649,
      'value': 696,
      'label': '鹤岗市'
    }, {'parent_id': 649, 'value': 705, 'label': '双鸭山市'}, {
      'parent_id': 649,
      'value': 714,
      'label': '大庆市'
    }, {'parent_id': 649, 'value': 724, 'label': '伊春市'}, {
      'parent_id': 649,
      'value': 742,
      'label': '佳木斯市'
    }, {'parent_id': 649, 'value': 753, 'label': '七台河市'}, {
      'parent_id': 649,
      'value': 758,
      'label': '牡丹江市'
    }, {'parent_id': 649, 'value': 769, 'label': '黑河市'}, {
      'parent_id': 649,
      'value': 776,
      'label': '绥化市'
    }, {'parent_id': 649, 'value': 787, 'label': '大兴安岭地区'}]
  }, {
    'parent_id': 0,
    'value': 792,
    'label': '上海市',
    'children': [{'parent_id': 792, 'value': 793, 'label': '上海市市辖区'}]
  }, {
    'parent_id': 0,
    'value': 810,
    'label': '江苏省',
    'children': [{'parent_id': 810, 'value': 811, 'label': '南京市'}, {
      'parent_id': 810,
      'value': 823,
      'label': '无锡市'
    }, {'parent_id': 810, 'value': 831, 'label': '徐州市'}, {
      'parent_id': 810,
      'value': 842,
      'label': '常州市'
    }, {'parent_id': 810, 'value': 849, 'label': '苏州市'}, {
      'parent_id': 810,
      'value': 859,
      'label': '南通市'
    }, {'parent_id': 810, 'value': 868, 'label': '连云港市'}, {
      'parent_id': 810,
      'value': 875,
      'label': '淮安市'
    }, {'parent_id': 810, 'value': 883, 'label': '盐城市'}, {
      'parent_id': 810,
      'value': 893,
      'label': '扬州市'
    }, {'parent_id': 810, 'value': 900, 'label': '镇江市'}, {
      'parent_id': 810,
      'value': 907,
      'label': '泰州市'
    }, {'parent_id': 810, 'value': 914, 'label': '宿迁市'}]
  }, {
    'parent_id': 0,
    'value': 920,
    'label': '浙江省',
    'children': [{'parent_id': 920, 'value': 921, 'label': '杭州市'}, {
      'parent_id': 920,
      'value': 935,
      'label': '宁波市'
    }, {'parent_id': 920, 'value': 946, 'label': '温州市'}, {
      'parent_id': 920,
      'value': 958,
      'label': '嘉兴市'
    }, {'parent_id': 920, 'value': 966, 'label': '湖州市'}, {
      'parent_id': 920,
      'value': 972,
      'label': '绍兴市'
    }, {'parent_id': 920, 'value': 979, 'label': '金华市'}, {
      'parent_id': 920,
      'value': 989,
      'label': '衢州市'
    }, {'parent_id': 920, 'value': 996, 'label': '舟山市'}, {
      'parent_id': 920,
      'value': 1001,
      'label': '台州市'
    }, {'parent_id': 920, 'value': 1011, 'label': '丽水市'}]
  }, {
    'parent_id': 0,
    'value': 1021,
    'label': '安徽省',
    'children': [{'parent_id': 1021, 'value': 1022, 'label': '合肥市'}, {
      'parent_id': 1021,
      'value': 1032,
      'label': '芜湖市'
    }, {'parent_id': 1021, 'value': 1041, 'label': '蚌埠市'}, {
      'parent_id': 1021,
      'value': 1049,
      'label': '淮南市'
    }, {'parent_id': 1021, 'value': 1057, 'label': '马鞍山市'}, {
      'parent_id': 1021,
      'value': 1064,
      'label': '淮北市'
    }, {'parent_id': 1021, 'value': 1069, 'label': '铜陵市'}, {
      'parent_id': 1021,
      'value': 1074,
      'label': '安庆市'
    }, {'parent_id': 1021, 'value': 1085, 'label': '黄山市'}, {
      'parent_id': 1021,
      'value': 1093,
      'label': '滁州市'
    }, {'parent_id': 1021, 'value': 1102, 'label': '阜阳市'}, {
      'parent_id': 1021,
      'value': 1111,
      'label': '宿州市'
    }, {'parent_id': 1021, 'value': 1117, 'label': '六安市'}, {
      'parent_id': 1021,
      'value': 1125,
      'label': '亳州市'
    }, {'parent_id': 1021, 'value': 1130, 'label': '池州市'}, {'parent_id': 1021, 'value': 1135, 'label': '宣城市'}]
  }, {
    'parent_id': 0,
    'value': 1143,
    'label': '福建省',
    'children': [{'parent_id': 1143, 'value': 1144, 'label': '福州市'}, {
      'parent_id': 1143,
      'value': 1158,
      'label': '厦门市'
    }, {'parent_id': 1143, 'value': 1165, 'label': '莆田市'}, {
      'parent_id': 1143,
      'value': 1171,
      'label': '三明市'
    }, {'parent_id': 1143, 'value': 1184, 'label': '泉州市'}, {
      'parent_id': 1143,
      'value': 1197,
      'label': '漳州市'
    }, {'parent_id': 1143, 'value': 1209, 'label': '南平市'}, {
      'parent_id': 1143,
      'value': 1220,
      'label': '龙岩市'
    }, {'parent_id': 1143, 'value': 1228, 'label': '宁德市'}]
  }, {
    'parent_id': 0,
    'value': 1238,
    'label': '江西省',
    'children': [{'parent_id': 1238, 'value': 1239, 'label': '南昌市'}, {
      'parent_id': 1238,
      'value': 1249,
      'label': '景德镇市'
    }, {'parent_id': 1238, 'value': 1254, 'label': '萍乡市'}, {
      'parent_id': 1238,
      'value': 1260,
      'label': '九江市'
    }, {'parent_id': 1238, 'value': 1274, 'label': '新余市'}, {
      'parent_id': 1238,
      'value': 1277,
      'label': '鹰潭市'
    }, {'parent_id': 1238, 'value': 1281, 'label': '赣州市'}, {
      'parent_id': 1238,
      'value': 1300,
      'label': '吉安市'
    }, {'parent_id': 1238, 'value': 1314, 'label': '宜春市'}, {
      'parent_id': 1238,
      'value': 1325,
      'label': '抚州市'
    }, {'parent_id': 1238, 'value': 1337, 'label': '上饶市'}]
  }, {
    'parent_id': 0,
    'value': 1350,
    'label': '山东省',
    'children': [{'parent_id': 1350, 'value': 1351, 'label': '济南市'}, {
      'parent_id': 1350,
      'value': 1362,
      'label': '青岛市'
    }, {'parent_id': 1350, 'value': 1373, 'label': '淄博市'}, {
      'parent_id': 1350,
      'value': 1382,
      'label': '枣庄市'
    }, {'parent_id': 1350, 'value': 1389, 'label': '东营市'}, {
      'parent_id': 1350,
      'value': 1395,
      'label': '烟台市'
    }, {'parent_id': 1350, 'value': 1408, 'label': '潍坊市'}, {
      'parent_id': 1350,
      'value': 1421,
      'label': '济宁市'
    }, {'parent_id': 1350, 'value': 1433, 'label': '泰安市'}, {
      'parent_id': 1350,
      'value': 1440,
      'label': '威海市'
    }, {'parent_id': 1350, 'value': 1445, 'label': '日照市'}, {
      'parent_id': 1350,
      'value': 1450,
      'label': '莱芜市'
    }, {'parent_id': 1350, 'value': 1453, 'label': '临沂市'}, {
      'parent_id': 1350,
      'value': 1466,
      'label': '德州市'
    }, {'parent_id': 1350, 'value': 1478, 'label': '聊城市'}, {
      'parent_id': 1350,
      'value': 1487,
      'label': '滨州市'
    }, {'parent_id': 1350, 'value': 1495, 'label': '菏泽市'}]
  }, {
    'parent_id': 0,
    'value': 1505,
    'label': '河南省',
    'children': [{'parent_id': 1505, 'value': 1506, 'label': '郑州市'}, {
      'parent_id': 1505,
      'value': 1519,
      'label': '开封市'
    }, {'parent_id': 1505, 'value': 1529, 'label': '洛阳市'}, {
      'parent_id': 1505,
      'value': 1545,
      'label': '平顶山市'
    }, {'parent_id': 1505, 'value': 1556, 'label': '安阳市'}, {
      'parent_id': 1505,
      'value': 1566,
      'label': '鹤壁市'
    }, {'parent_id': 1505, 'value': 1572, 'label': '新乡市'}, {
      'parent_id': 1505,
      'value': 1585,
      'label': '焦作市'
    }, {'parent_id': 1505, 'value': 1596, 'label': '濮阳市'}, {
      'parent_id': 1505,
      'value': 1603,
      'label': '许昌市'
    }, {'parent_id': 1505, 'value': 1610, 'label': '漯河市'}, {
      'parent_id': 1505,
      'value': 1616,
      'label': '三门峡市'
    }, {'parent_id': 1505, 'value': 1623, 'label': '南阳市'}, {
      'parent_id': 1505,
      'value': 1637,
      'label': '商丘市'
    }, {'parent_id': 1505, 'value': 1647, 'label': '信阳市'}, {
      'parent_id': 1505,
      'value': 1658,
      'label': '周口市'
    }, {'parent_id': 1505, 'value': 1669, 'label': '驻马店市'}, {'parent_id': 1505, 'value': 1680, 'label': '济源市'}]
  }, {
    'parent_id': 0,
    'value': 1681,
    'label': '湖北省',
    'children': [{'parent_id': 1681, 'value': 1682, 'label': '武汉市'}, {
      'parent_id': 1681,
      'value': 1696,
      'label': '黄石市'
    }, {'parent_id': 1681, 'value': 1703, 'label': '十堰市'}, {
      'parent_id': 1681,
      'value': 1712,
      'label': '宜昌市'
    }, {'parent_id': 1681, 'value': 1726, 'label': '襄阳市'}, {
      'parent_id': 1681,
      'value': 1736,
      'label': '鄂州市'
    }, {'parent_id': 1681, 'value': 1740, 'label': '荆门市'}, {
      'parent_id': 1681,
      'value': 1746,
      'label': '孝感市'
    }, {'parent_id': 1681, 'value': 1754, 'label': '荆州市'}, {
      'parent_id': 1681,
      'value': 1763,
      'label': '黄冈市'
    }, {'parent_id': 1681, 'value': 1774, 'label': '咸宁市'}, {
      'parent_id': 1681,
      'value': 1781,
      'label': '随州市'
    }, {'parent_id': 1681, 'value': 1785, 'label': '恩施土家族苗族自治州'}, {
      'parent_id': 1681,
      'value': 1794,
      'label': '仙桃市'
    }, {'parent_id': 1681, 'value': 1795, 'label': '潜江市'}, {
      'parent_id': 1681,
      'value': 1796,
      'label': '天门市'
    }, {'parent_id': 1681, 'value': 1797, 'label': '神农架林区'}]
  }, {
    'parent_id': 0,
    'value': 1798,
    'label': '湖南省',
    'children': [{'parent_id': 1798, 'value': 1799, 'label': '长沙市'}, {
      'parent_id': 1798,
      'value': 1809,
      'label': '株洲市'
    }, {'parent_id': 1798, 'value': 1819, 'label': '湘潭市'}, {
      'parent_id': 1798,
      'value': 1825,
      'label': '衡阳市'
    }, {'parent_id': 1798, 'value': 1838, 'label': '邵阳市'}, {
      'parent_id': 1798,
      'value': 1851,
      'label': '岳阳市'
    }, {'parent_id': 1798, 'value': 1861, 'label': '常德市'}, {
      'parent_id': 1798,
      'value': 1871,
      'label': '张家界市'
    }, {'parent_id': 1798, 'value': 1876, 'label': '益阳市'}, {
      'parent_id': 1798,
      'value': 1883,
      'label': '郴州市'
    }, {'parent_id': 1798, 'value': 1895, 'label': '永州市'}, {
      'parent_id': 1798,
      'value': 1907,
      'label': '怀化市'
    }, {'parent_id': 1798, 'value': 1920, 'label': '娄底市'}, {'parent_id': 1798, 'value': 1926, 'label': '湘西土家族苗族自治州'}]
  }, {
    'parent_id': 0,
    'value': 1935,
    'label': '广东省',
    'children': [{'parent_id': 1935, 'value': 1936, 'label': '广州市'}, {
      'parent_id': 1935,
      'value': 1948,
      'label': '韶关市'
    }, {'parent_id': 1935, 'value': 1959, 'label': '深圳市'}, {
      'parent_id': 1935,
      'value': 1966,
      'label': '珠海市'
    }, {'parent_id': 1935, 'value': 1970, 'label': '汕头市'}, {
      'parent_id': 1935,
      'value': 1978,
      'label': '佛山市'
    }, {'parent_id': 1935, 'value': 1984, 'label': '江门市'}, {
      'parent_id': 1935,
      'value': 1992,
      'label': '湛江市'
    }, {'parent_id': 1935, 'value': 2002, 'label': '茂名市'}, {
      'parent_id': 1935,
      'value': 2008,
      'label': '肇庆市'
    }, {'parent_id': 1935, 'value': 2017, 'label': '惠州市'}, {
      'parent_id': 1935,
      'value': 2023,
      'label': '梅州市'
    }, {'parent_id': 1935, 'value': 2032, 'label': '汕尾市'}, {
      'parent_id': 1935,
      'value': 2037,
      'label': '河源市'
    }, {'parent_id': 1935, 'value': 2044, 'label': '阳江市'}, {
      'parent_id': 1935,
      'value': 2049,
      'label': '清远市'
    }, {'parent_id': 1935, 'value': 2058, 'label': '东莞市'}, {
      'parent_id': 1935,
      'value': 2062,
      'label': '中山市'
    }, {'parent_id': 1935, 'value': 2065, 'label': '潮州市'}, {
      'parent_id': 1935,
      'value': 2069,
      'label': '揭阳市'
    }, {'parent_id': 1935, 'value': 2075, 'label': '云浮市'}]
  }, {
    'parent_id': 0,
    'value': 2081,
    'label': '广西壮族自治区',
    'children': [{'parent_id': 2081, 'value': 2082, 'label': '南宁市'}, {
      'parent_id': 2081,
      'value': 2095,
      'label': '柳州市'
    }, {'parent_id': 2081, 'value': 2106, 'label': '桂林市'}, {
      'parent_id': 2081,
      'value': 2124,
      'label': '梧州市'
    }, {'parent_id': 2081, 'value': 2132, 'label': '北海市'}, {
      'parent_id': 2081,
      'value': 2137,
      'label': '防城港市'
    }, {'parent_id': 2081, 'value': 2142, 'label': '钦州市'}, {
      'parent_id': 2081,
      'value': 2147,
      'label': '贵港市'
    }, {'parent_id': 2081, 'value': 2153, 'label': '玉林市'}, {
      'parent_id': 2081,
      'value': 2161,
      'label': '百色市'
    }, {'parent_id': 2081, 'value': 2174, 'label': '贺州市'}, {
      'parent_id': 2081,
      'value': 2180,
      'label': '河池市'
    }, {'parent_id': 2081, 'value': 2192, 'label': '来宾市'}, {'parent_id': 2081, 'value': 2199, 'label': '崇左市'}]
  }, {
    'parent_id': 0,
    'value': 2207,
    'label': '海南省',
    'children': [{'parent_id': 2207, 'value': 2208, 'label': '海口市'}, {
      'parent_id': 2207,
      'value': 2213,
      'label': '三亚市'
    }, {'parent_id': 2207, 'value': 2225, 'label': '三沙市'}, {
      'parent_id': 2207,
      'value': 2229,
      'label': '儋州市'
    }, {'parent_id': 2207, 'value': 2230, 'label': '五指山市'}, {
      'parent_id': 2207,
      'value': 2231,
      'label': '琼海市'
    }, {'parent_id': 2207, 'value': 2232, 'label': '文昌市'}, {
      'parent_id': 2207,
      'value': 2233,
      'label': '万宁市'
    }, {'parent_id': 2207, 'value': 2234, 'label': '东方市'}, {
      'parent_id': 2207,
      'value': 2235,
      'label': '定安县'
    }, {'parent_id': 2207, 'value': 2236, 'label': '屯昌县'}, {
      'parent_id': 2207,
      'value': 2237,
      'label': '澄迈县'
    }, {'parent_id': 2207, 'value': 2238, 'label': '临高县'}, {
      'parent_id': 2207,
      'value': 2239,
      'label': '白沙黎族自治县'
    }, {'parent_id': 2207, 'value': 2240, 'label': '昌江黎族自治县'}, {
      'parent_id': 2207,
      'value': 2241,
      'label': '乐东黎族自治县'
    }, {'parent_id': 2207, 'value': 2242, 'label': '陵水黎族自治县'}, {
      'parent_id': 2207,
      'value': 2243,
      'label': '保亭黎族苗族自治县'
    }, {'parent_id': 2207, 'value': 2244, 'label': '琼中黎族苗族自治县'}]
  }, {
    'parent_id': 0,
    'value': 2245,
    'label': '重庆市',
    'children': [{'parent_id': 2245, 'value': 2246, 'label': '重庆市市辖区'}, {
      'parent_id': 2245,
      'value': 2285,
      'label': '重庆市郊县'
    }]
  }, {
    'parent_id': 0,
    'value': 2286,
    'label': '四川省',
    'children': [{'parent_id': 2286, 'value': 2287, 'label': '成都市'}, {
      'parent_id': 2286,
      'value': 2308,
      'label': '自贡市'
    }, {'parent_id': 2286, 'value': 2315, 'label': '攀枝花市'}, {
      'parent_id': 2286,
      'value': 2321,
      'label': '泸州市'
    }, {'parent_id': 2286, 'value': 2329, 'label': '德阳市'}, {
      'parent_id': 2286,
      'value': 2336,
      'label': '绵阳市'
    }, {'parent_id': 2286, 'value': 2346, 'label': '广元市'}, {
      'parent_id': 2286,
      'value': 2354,
      'label': '遂宁市'
    }, {'parent_id': 2286, 'value': 2360, 'label': '内江市'}, {
      'parent_id': 2286,
      'value': 2366,
      'label': '乐山市'
    }, {'parent_id': 2286, 'value': 2378, 'label': '南充市'}, {
      'parent_id': 2286,
      'value': 2388,
      'label': '眉山市'
    }, {'parent_id': 2286, 'value': 2395, 'label': '宜宾市'}, {
      'parent_id': 2286,
      'value': 2406,
      'label': '广安市'
    }, {'parent_id': 2286, 'value': 2413, 'label': '达州市'}, {
      'parent_id': 2286,
      'value': 2421,
      'label': '雅安市'
    }, {'parent_id': 2286, 'value': 2430, 'label': '巴中市'}, {
      'parent_id': 2286,
      'value': 2436,
      'label': '资阳市'
    }, {'parent_id': 2286, 'value': 2440, 'label': '阿坝藏族羌族自治州'}, {
      'parent_id': 2286,
      'value': 2454,
      'label': '甘孜藏族自治州'
    }, {'parent_id': 2286, 'value': 2473, 'label': '凉山彝族自治州'}]
  }, {
    'parent_id': 0,
    'value': 2491,
    'label': '贵州省',
    'children': [{'parent_id': 2491, 'value': 2492, 'label': '贵阳市'}, {
      'parent_id': 2491,
      'value': 2503,
      'label': '六盘水市'
    }, {'parent_id': 2491, 'value': 2508, 'label': '遵义市'}, {
      'parent_id': 2491,
      'value': 2523,
      'label': '安顺市'
    }, {'parent_id': 2491, 'value': 2530, 'label': '毕节市'}, {
      'parent_id': 2491,
      'value': 2539,
      'label': '铜仁市'
    }, {'parent_id': 2491, 'value': 2550, 'label': '黔西南布依族苗族自治州'}, {
      'parent_id': 2491,
      'value': 2559,
      'label': '黔东南苗族侗族自治州'
    }, {'parent_id': 2491, 'value': 2576, 'label': '黔南布依族苗族自治州'}]
  }, {
    'parent_id': 0,
    'value': 2589,
    'label': '云南省',
    'children': [{'parent_id': 2589, 'value': 2590, 'label': '昆明市'}, {
      'parent_id': 2589,
      'value': 2605,
      'label': '曲靖市'
    }, {'parent_id': 2589, 'value': 2615, 'label': '玉溪市'}, {
      'parent_id': 2589,
      'value': 2625,
      'label': '保山市'
    }, {'parent_id': 2589, 'value': 2631, 'label': '昭通市'}, {
      'parent_id': 2589,
      'value': 2643,
      'label': '丽江市'
    }, {'parent_id': 2589, 'value': 2649, 'label': '普洱市'}, {
      'parent_id': 2589,
      'value': 2660,
      'label': '临沧市'
    }, {'parent_id': 2589, 'value': 2669, 'label': '楚雄彝族自治州'}, {
      'parent_id': 2589,
      'value': 2680,
      'label': '红河哈尼族彝族自治州'
    }, {'parent_id': 2589, 'value': 2694, 'label': '文山壮族苗族自治州'}, {
      'parent_id': 2589,
      'value': 2703,
      'label': '西双版纳傣族自治州'
    }, {'parent_id': 2589, 'value': 2707, 'label': '大理白族自治州'}, {
      'parent_id': 2589,
      'value': 2720,
      'label': '德宏傣族景颇族自治州'
    }, {'parent_id': 2589, 'value': 2726, 'label': '怒江傈僳族自治州'}, {
      'parent_id': 2589,
      'value': 2731,
      'label': '迪庆藏族自治州'
    }]
  }, {
    'parent_id': 0,
    'value': 2735,
    'label': '西藏自治区',
    'children': [{'parent_id': 2735, 'value': 2736, 'label': '拉萨市'}, {
      'parent_id': 2735,
      'value': 2745,
      'label': '日喀则市'
    }, {'parent_id': 2735, 'value': 2764, 'label': '昌都市'}, {
      'parent_id': 2735,
      'value': 2776,
      'label': '山南市'
    }, {'parent_id': 2735, 'value': 2789, 'label': '那曲地区'}, {
      'parent_id': 2735,
      'value': 2801,
      'label': '阿里地区'
    }, {'parent_id': 2735, 'value': 2809, 'label': '林芝市'}]
  }, {
    'parent_id': 0,
    'value': 2817,
    'label': '陕西省',
    'children': [{'parent_id': 2817, 'value': 2818, 'label': '西安市'}, {
      'parent_id': 2817,
      'value': 2832,
      'label': '铜川市'
    }, {'parent_id': 2817, 'value': 2837, 'label': '宝鸡市'}, {
      'parent_id': 2817,
      'value': 2850,
      'label': '咸阳市'
    }, {'parent_id': 2817, 'value': 2865, 'label': '渭南市'}, {
      'parent_id': 2817,
      'value': 2877,
      'label': '延安市'
    }, {'parent_id': 2817, 'value': 2891, 'label': '汉中市'}, {
      'parent_id': 2817,
      'value': 2903,
      'label': '榆林市'
    }, {'parent_id': 2817, 'value': 2916, 'label': '安康市'}, {'parent_id': 2817, 'value': 2927, 'label': '商洛市'}]
  }, {
    'parent_id': 0,
    'value': 2935,
    'label': '甘肃省',
    'children': [{'parent_id': 2935, 'value': 2936, 'label': '兰州市'}, {
      'parent_id': 2935,
      'value': 2945,
      'label': '嘉峪关市'
    }, {'parent_id': 2935, 'value': 2946, 'label': '金昌市'}, {
      'parent_id': 2935,
      'value': 2949,
      'label': '白银市'
    }, {'parent_id': 2935, 'value': 2955, 'label': '天水市'}, {
      'parent_id': 2935,
      'value': 2963,
      'label': '武威市'
    }, {'parent_id': 2935, 'value': 2968, 'label': '张掖市'}, {
      'parent_id': 2935,
      'value': 2975,
      'label': '平凉市'
    }, {'parent_id': 2935, 'value': 2983, 'label': '酒泉市'}, {
      'parent_id': 2935,
      'value': 2991,
      'label': '庆阳市'
    }, {'parent_id': 2935, 'value': 3000, 'label': '定西市'}, {
      'parent_id': 2935,
      'value': 3008,
      'label': '陇南市'
    }, {'parent_id': 2935, 'value': 3018, 'label': '临夏回族自治州'}, {'parent_id': 2935, 'value': 3027, 'label': '甘南藏族自治州'}]
  }, {
    'parent_id': 0,
    'value': 3036,
    'label': '青海省',
    'children': [{'parent_id': 3036, 'value': 3037, 'label': '西宁市'}, {
      'parent_id': 3036,
      'value': 3045,
      'label': '海东市'
    }, {'parent_id': 3036, 'value': 3052, 'label': '海北藏族自治州'}, {
      'parent_id': 3036,
      'value': 3057,
      'label': '黄南藏族自治州'
    }, {'parent_id': 3036, 'value': 3062, 'label': '海南藏族自治州'}, {
      'parent_id': 3036,
      'value': 3068,
      'label': '果洛藏族自治州'
    }, {'parent_id': 3036, 'value': 3075, 'label': '玉树藏族自治州'}, {
      'parent_id': 3036,
      'value': 3082,
      'label': '海西蒙古族藏族自治州'
    }]
  }, {
    'parent_id': 0,
    'value': 3089,
    'label': '宁夏回族自治区',
    'children': [{'parent_id': 3089, 'value': 3090, 'label': '银川市'}, {
      'parent_id': 3089,
      'value': 3097,
      'label': '石嘴山市'
    }, {'parent_id': 3089, 'value': 3101, 'label': '吴忠市'}, {
      'parent_id': 3089,
      'value': 3107,
      'label': '固原市'
    }, {'parent_id': 3089, 'value': 3113, 'label': '中卫市'}]
  }, {
    'parent_id': 0,
    'value': 3117,
    'label': '新疆维吾尔自治区',
    'children': [{'parent_id': 3117, 'value': 3118, 'label': '乌鲁木齐市'}, {
      'parent_id': 3117,
      'value': 3127,
      'label': '克拉玛依市'
    }, {'parent_id': 3117, 'value': 3132, 'label': '吐鲁番市'}, {
      'parent_id': 3117,
      'value': 3136,
      'label': '哈密市'
    }, {'parent_id': 3117, 'value': 3140, 'label': '昌吉回族自治州'}, {
      'parent_id': 3117,
      'value': 3148,
      'label': '博尔塔拉蒙古自治州'
    }, {'parent_id': 3117, 'value': 3153, 'label': '巴音郭楞蒙古自治州'}, {
      'parent_id': 3117,
      'value': 3163,
      'label': '阿克苏地区'
    }, {'parent_id': 3117, 'value': 3173, 'label': '克孜勒苏柯尔克孜自治州'}, {
      'parent_id': 3117,
      'value': 3178,
      'label': '喀什地区'
    }, {'parent_id': 3117, 'value': 3191, 'label': '和田地区'}, {
      'parent_id': 3117,
      'value': 3200,
      'label': '伊犁哈萨克自治州'
    }, {'parent_id': 3117, 'value': 3212, 'label': '塔城地区'}, {
      'parent_id': 3117,
      'value': 3220,
      'label': '阿勒泰地区'
    }, {'parent_id': 3117, 'value': 3228, 'label': '石河子市'}, {
      'parent_id': 3117,
      'value': 3229,
      'label': '阿拉尔市'
    }, {'parent_id': 3117, 'value': 3230, 'label': '图木舒克市'}, {
      'parent_id': 3117,
      'value': 3231,
      'label': '五家渠市'
    }, {'parent_id': 3117, 'value': 3232, 'label': '北屯市'}, {
      'parent_id': 3117,
      'value': 3233,
      'label': '铁门关市'
    }, {'parent_id': 3117, 'value': 3234, 'label': '双河市'}, {
      'parent_id': 3117,
      'value': 3235,
      'label': '可克达拉市'
    }, {'parent_id': 3117, 'value': 3236, 'label': '昆玉市'}]
  }, {
    'parent_id': 0,
    'value': 3237,
    'label': '台湾省',
    'children': [{'parent_id': 3237, 'value': 51250, 'label': '(台湾)'}]
  }, {
    'parent_id': 0,
    'value': 3238,
    'label': '香港特别行政区',
    'children': [{'parent_id': 3238, 'value': 3239, 'label': '香港特别行政区'}]
  }, {
    'parent_id': 0,
    'value': 3258,
    'label': '澳门特别行政区',
    'children': [{'parent_id': 3258, 'value': 3259, 'label': '澳门特别行政区'}]
  }
];
import mixin from '../../js/mixins';
export default {
  mixins: [mixin.fetchSelect, mixin.addEdit],
  name: 'testSetForm_1',
  data () {
    return {
      targetKeys: [],
      selectedKeys: [],
      itemLayout: {
        labelCol: {span: 8},
        wrapperCol: {span: 9}
      },
      formList: [
        {
          label: '应用范围',
          inputType: 'select',
          options: [
            {label: '全部用户', value: 0},
            {label: '指定城市', value: 1},
            {label: '指定小区', value: 2},
            {label: '指定用户', value: 3}
          ],
          placeholder: '请选择应用范围',
          handle: this.handleUserRange,
          isShow: true,
          props: ['scope_type', {
            rules: [{required: true, message: '请选择用户范围'}]
          }]
        },
        {
          label: '选择城市',
          inputType: 'treeSelect',
          options: [],
          placeholder: '请选择城市',
          isShow: true,
          props: ['city_scope', {
            rules: [{required: true, message: '请选择城市'}]
          }]
        },
        {
          label: '选择小区',
          inputType: 'transfer',
          options: [],
          placeholder: '',
          isShow: true,
          props: ['community_scope', {
            rules: [{required: true, message: '请选择小区'}]
          }],
          titles: ['小区列表', '已选']
        },
        {
          label: '输入账号',
          inputType: 'textarea',
          extra: '多个账号以英文“,”逗号隔开',
          isShow: true,
          props: ['account_scope', {
            rules: [{required: true, message: '请输入账号'}]
          }]
        }
      ]
    };
  },
  beforeCreate () {
    this.form = this.$form.createForm(this);
  },
  created () {
    this.userRangeList(1, 2);
    let keyArr = ['city_scope', 'community_scope', 'account_scope'];
    this.formList.forEach((el) => {
      let isSame = keyArr.some(item => item === (el.props && el.props[0]));
      isSame && (el.isShow = false);
    });
  },
  mounted () {
    this.form.setFieldsValue({ scope_type: 1 });
  },
  methods: {
    /* 处理用户范围 */
    handleUserRange (val) {
      let scopeType = {
        0: {city_scope: false, community_scope: false, account_scope: false},
        1: {city_scope: true, community_scope: false, account_scope: false},
        2: {city_scope: false, community_scope: true, account_scope: false},
        3: {city_scope: false, community_scope: false, account_scope: true}
      };
      this.formList.forEach(el => {
        let props = el.props && el.props[0];
        let scopeObj = scopeType[val];
        for (let item in scopeObj) {
          if (props === item) {
            el.isShow = scopeObj[item];
          }
        }
      });
      let valType = {
        1: {city_scope: ['1144', '1158', '301', '316', '1959']},
        2: {community_scope: ['1', '2']},
        3: {account_scope: '15060740100'}
      };
      this.$nextTick(() => {
        if (val === 2) {
          this.targetKeys = ['1', '2'];
        }
        this.form.setFieldsValue(valType[val]);
      });
    },
    handleSubmit () {
      this.form.validateFields((err, values) => {
        if (err) {
          console.log('err', err, values);
        }
        console.log('no err', values);
      });
    },
    transferSelectChange (sourceSelectedKeys, targetSelectedKeys) {
      this.selectedKeys = [...sourceSelectedKeys, ...targetSelectedKeys];
    },
    transferChange (nextTargetKeys, direction, moveKeys) {
      this.targetKeys = nextTargetKeys;
    },
    /* 穿梭框搜索 */
    transferFilter (inputValue, option) {
      return option.title.toLowerCase().indexOf(inputValue) > -1;
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/test/testSetForm_1.vue